import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const requiredRoles = route.data['roles'];
    const userRoles = this.authService.getUserRoles();

    if (!requiredRoles || requiredRoles.some((role: string) => userRoles.includes(role))) {
      return true;
    }

    // Action 1: Redirect user to home page
    return this.router.parseUrl('/');
  }
}

@Injectable({
  providedIn: 'root'
})
export class ButtonStateService {
  constructor(private authService: AuthService) {}

  // Action 2: Disable button based on roles
  isButtonDisabled(requiredRoles: string[]): boolean {
    const userRoles = this.authService.getUserRoles();
    return !requiredRoles.some(role => userRoles.includes(role));
  }
}

@Injectable({
  providedIn: 'root'
})
export class ComponentVisibilityService {
  constructor(private authService: AuthService) {}

  // Action 3: Hide component based on roles
  isComponentHidden(requiredRoles: string[]): boolean {
    const userRoles = this.authService.getUserRoles();
    return !requiredRoles.some(role => userRoles.includes(role));
  }
}